"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliceBox = exports.PopperButton = exports.Popper = exports.InvisibleButton = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Layout = require("../../Layout");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var InvisibleButton = _styledComponents.default.button(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  margin: 0;\n\n  &:hover {\n    background-color: none;\n  }\n\n  &:focus {\n    border: none;\n  }\n"], ["\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  margin: 0;\n\n  &:hover {\n    background-color: none;\n  }\n\n  &:focus {\n    border: none;\n  }\n"])));

exports.InvisibleButton = InvisibleButton;

var Popper = _styledComponents.default.div(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  z-index: 1001;\n"], ["\n  z-index: 1001;\n"])));

exports.Popper = Popper;

var PopperButton = _styledComponents.default.button(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  background-color: transparent;\n  border: none;\n\n  &:not([aria-label=\"\"]) {\n    padding: 2px 0 0 0;\n  }\n\n  :focus-visible {\n    outline: 2px solid black;\n\n    &:not([aria-label=\"\"]) {\n      outline-offset: 0;\n    }\n  }\n"], ["\n  background-color: transparent;\n  border: none;\n\n  &:not([aria-label=\"\"]) {\n    padding: 2px 0 0 0;\n  }\n\n  :focus-visible {\n    outline: 2px solid black;\n\n    &:not([aria-label=\"\"]) {\n      outline-offset: 0;\n    }\n  }\n"])));

exports.PopperButton = PopperButton;
var SliceBox = (0, _styledComponents.default)(_Layout.Box)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  align-content: end;\n  display: flex;\n"], ["\n  align-content: end;\n  display: flex;\n"])));
exports.SliceBox = SliceBox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;